import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'Login/AUTH_ERROR',
    PENDING: 'Login/AUTH_PENDING',
    SUCCESS: 'Login/AUTH_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
